<template>
	<div class="brick">
		<div class="list_top_box">
			<ItemClassSelectMultiS v-model="param.itemClasses" ref="ItemClassSelectMulti" :includeClosedYn="'Y'" :classCodeToAdd="classCodeToAdd" />
			<label>
				<em class="lt_text">{{ headers.class }} Active</em>
				<span class="int_type mgr_5">
					<select v-model="param.classActive" class="tbl_select sm_int">
						<option value="A">All</option>
						<option value="Y">Active</option>
						<option value="N">Not Active</option>
					</select>
				</span>
			</label>
			<label>
				<em class="lt_text">{{ headers.class }} Closed</em>
				<span class="int_type mgr_5">
					<select v-model="param.classClosed" class="tbl_select sm_int">
						<option value="A">All</option>
						<option value="Y">Closed</option>
						<option value="N">Not Closed</option>
					</select>
				</span>
			</label>

			<label>
				<em class="lt_text">Item Active</em>
				<span class="int_type mgr_5">
					<select v-model="param.itemActive" class="tbl_select sm_int">
						<option value="A">All</option>
						<option value="Y">Active</option>
						<option value="N">Not Active</option>
					</select>
				</span>
			</label>

			<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
			<a href="javascript:void(0);" class="gray_bt mgr_15" @click="reset()">Reset</a>

			<input
				type="text"
				ref="barcode_to_find"
				class="tbl_int"
				v-model.trim="barcode_to_find"
				placeholder="Barcode Scan to Search"
				autocomplete="off"
				style="width:170px;"
				@keypress.enter="barcodeScan($event)"
				@focus="$event.target.select()"
			/>

			<a href="javascript:void(0);" class="gray_bt fl_r" @click="print">Print</a>
			<a href="javascript:void(0);" class="gray_bt mgr_5 fl_r" @click="whPrint">WH Print</a>
			<a v-if="isBpNHp" href="javascript:void(0);" class="gray_bt fl_r mgr_5" @click="printWhBoxLabel()">Box Label(2nd)</a>
			<a href="javascript:void(0);" class="gray_bt fl_r mgr_5" @click="printBoxLabel(false)">Box Label</a>
			<a href="javascript:void(0);" class="gray_bt fl_r mgr_5" @click="printBoxLabel(true)">ZPL Box Label</a>
			<a href="javascript:void(0);" class="gray_bt mgr_5 fl_r" @click="printClassLocation">{{ headers.class }} Location</a>
		</div>
		<div class="fixed-table-container-none-padding">
			<div ref="table_wrapper_div" class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<colgroup>
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col />
						<col style="width: 5%" />
						<col style="width: 5%" />
						<col style="width: 5%" />
						<col style="width: 5%" />
						<col style="width: 15%" />
						<col style="width: 7%" />
						<col style="width: 5%" />
						<col style="width: 5%" />
					</colgroup>
					<thead>
						<tr>
							<th>Item {{ headers.class }} Code</th>
							<th>2nd Code</th>
							<th>Item {{ headers.class }} Name</th>
							<th>Class Active</th>
							<th>Class Closed</th>
							<th>Rack</th>
							<th>Section</th>
							<th><input type="checkbox" v-model="itemColorCheckBox" @change="allCheck" />Item Color</th>
							<th>Color 2nd Code</th>
							<th>On Hand</th>
							<th>Item Active</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="(cls, index) in data.list">
							<tr v-for="(item, jIndex) in cls.items" :key="cls.itemClass.code + item.item_id">
								<td>
									<span v-if="jIndex === 0"> {{ cls.itemClass.code }}</span>
								</td>
								<td>
									<span v-if="jIndex === 0">{{ cls.itemClass.wh_code }}</span>
								</td>
								<td>
									<span v-if="jIndex === 0">{{ cls.itemClass.name }}</span>
								</td>
								<td class="al_center">
									<span v-if="jIndex === 0"> {{ cls.itemClass.active_yn }}</span>
								</td>
								<td class="al_center">
									<span v-if="jIndex === 0"> {{ cls.itemClass.closed_yn }}</span>
								</td>
								<td class="al_center">
									<span v-if="jIndex === 0">{{ cls.itemClass.rack }}</span>
								</td>
								<td class="al_center">
									<span v-if="jIndex === 0">{{ cls.itemClass.section }}</span>
								</td>
								<td>
									<p>
										<input type="checkbox" v-model="boxLabelArr" :value="item.item_id" />
										<!-- <input type="checkbox" v-model="boxLabelArr" :value="{ item_class_code: cls.itemClass.code, item_class_name: cls.itemClass.name, item_color: item.color_code, item_amount: item.amount }" /> -->
										<span>
											{{ item.color_code }}
										</span>
										<currency-input
											:ref="`${index}/${jIndex}`"
											type="text"
											:precision="0"
											v-model.trim="item.amount"
											class="tbl_int sssm_int al_right right_option"
											@focus="$event.target.select()"
											@keydown.enter.prevent="keyDown(index, jIndex + 1)"
										/>
									</p>
								</td>
								<td>
									<span>{{ item.wh_color_code }}</span>
								</td>
								<td class="al_right">
									<span>{{ item.on_hand | commaSeparated }}</span>
								</td>
								<td class="al_center">
									<span>{{ item.active_yn }}</span>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="whPrint">WH Print</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="print">Print</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import { apiInventorySheet } from '@/api/report/report';
import { apiSelectItem } from '@/api/item/master.js';
import { apiSelectLocationByClass } from '@/api/item/class.js';
import { objectToUrlParam, reportMrtUrl, reportRender } from '@/api/util';
import { zplPrint, commaSeparated } from '@/utils/etc.js';

export default {
	name: 'InventorySheet',
	props: ['headers'],
	data() {
		return {
			param: {
				itemClasses: [],
				classActive: 'A',
				classClosed: 'A',
				itemActive: 'A',
			},
			data: {
				list: [],
			},
			barcode_to_find: null,
			boxLabelArr: [],
			itemColorCheckBox: false,

			classCodeToAdd: null, // barcode로 검색한 Class Code
		};
	},
	components: {
		ItemClassSelectMultiS,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user && this.user.company_id ? this.user.company_id : '';
		},
		isBpNHp() {
			return ['beautyplus', 'hairplus'].includes(this.company_id);
		},
	},
	methods: {
		async barcodeScan(event) {
			const { data } = await apiSelectItem({
				barcode: this.barcode_to_find,
			});
			//console.log(data);
			if (data.item) {
				//console.log(data.item.class_code);
				// this.param.itemClasses.push(data.item.class_code);
				// this.search();
				this.classCodeToAdd = data.item.class_code;
				event.target.select();
				this.$nextTick(() => {
					this.search();
				});
			} else {
				this.$toast.error('Item Not Found');
			}
			return false;
		},
		async search() {
			const { data } = await apiInventorySheet(objectToUrlParam(this.param));
			this.data = data;
			this.boxLabelArr = [];
		},

		reset() {
			this.$refs.ItemClassSelectMulti.reset();
			Object.assign(this.$data, this.$options.data());
		},

		keyDown(index, jIndex) {
			if (this.data.list.length - 1 < index) {
				index = 0;
				jIndex = 0;
			}

			if (!this.data.list[index].items || !this.data.list[index].items.length || this.data.list[index].items.length - 1 < jIndex) {
				this.keyDown(++index, 0);
				return;
			}

			this.$refs[`${index}/${jIndex}`][0].$el.select();

			const input_rect = this.$refs[`${index}/${jIndex}`][0].$el.getBoundingClientRect();
			const wrapper_rect = this.$refs.table_wrapper_div.getBoundingClientRect();
			if (input_rect.top - wrapper_rect.bottom * 0.7 > 0) this.$refs.table_wrapper_div.scrollTop += input_rect.top - wrapper_rect.bottom * 0.7;
			else if (input_rect.top < wrapper_rect.top) this.$refs.table_wrapper_div.scrollTop = 0;
		},
		async printClassLocation() {
			if (!Array.isArray(this.data.list) || !this.data.list.length) {
				this.$toast.error('No Data to be Shown.');
				return;
			}
			const class_list = this.data.list.map(cls => cls.itemClass.code);
			const { data } = await apiSelectLocationByClass(class_list);
			// console.log(JSON.stringify({ class_display: this.headers.class, list: data }, null, 4));
			await reportRender({ class_display: this.headers.class, list: data }, this.headers.class + 'Location', reportMrtUrl('ClassLocation'));
		},
		async print() {
			await reportRender(this.data, 'InventorySheet', reportMrtUrl('InventorySheet'));
		},

		async whPrint() {
			await reportRender(this.data, 'WHInventorySheet', reportMrtUrl('WHInventorySheet'));
		},
		async printWhBoxLabel() {
			if (this.boxLabelArr.length < 1) return this.$toast.error('Please, Select Item Color to Print Box Label');

			let boxLabelArr = [];
			for (const boxLabel of this.boxLabelArr) {
				if (this.data.list.length < 1) continue;

				let isContinue = true;
				for (const el of this.data.list) {
					if (el.items.length < 1) continue;

					for (const item of el.items) {
						if (item.item_id === boxLabel) {
							boxLabelArr.push({
								class_code: el.itemClass.code,
								wh_class_code: el.itemClass.wh_code,
								class_name: el.itemClass.name,
								color_code: item.color_code,
								wh_color_code: item.wh_color_code,
								barcode: item.barcode,
								packing: item.amount || item.packing,
								po_hidden_yn: 'Y',
								ctn_hidden_yn: 'Y',
							});

							isContinue = false;
							break;
						}
					}

					if (!isContinue) break;
				}
			}

			await reportRender({ value: boxLabelArr }, 'label', reportMrtUrl('label'));
		},
		async printBoxLabel(isZPL) {
			if (this.boxLabelArr.length < 1) return this.$toast.error('Please, Select Item Color to Print Box Label');

			let boxLabelArr = [];
			for (const boxLabel of this.boxLabelArr) {
				if (this.data.list.length < 1) continue;

				let isContinue = true;
				for (const el of this.data.list) {
					if (el.items.length < 1) continue;

					for (const item of el.items) {
						if (item.item_id === boxLabel) {
							boxLabelArr.push({ item_class_code: el.itemClass.code, item_class_name: el.itemClass.name, item_color: item.color_code, item_amount: item.amount || item.packing, barcode: item.barcode });
							isContinue = false;
							break;
						}
					}

					if (!isContinue) break;
				}
			}

			if (!isZPL) {
				await reportRender(boxLabelArr, 'InventorySheetBoxLabel', reportMrtUrl('InventorySheetBoxLabel'));
			} else {
				// if (boxLabelArr.length > 50) return this.$toast.error('The Maximum Label Count of ZPL is 50.');
				// 6inch : 4inch + 200dpi
				// inch : 203 dot
				let str_body = '';

				let padding_outer = 50;
				let padding_inner = 20;
				let line_thick = 4;

				let width = 203 * 6 - padding_outer * 2;
				let height = 203 * 4 - padding_outer * 2;

				let code_height = Math.floor(height / 4);
				let color_height = Math.floor(height / 4);
				let pcs_label_height = Math.ceil(color_height * 0.3);
				let pcs_height = color_height - pcs_label_height;
				let name_height = height - code_height - color_height;

				let permit_limit = 3;
				let big_font_size = 120;

				const makeRowInfo = function(str, font_size, width_percent) {
					if (typeof str === 'number') str = commaSeparated(str);

					if (!str) str = '';
					else str = str.trim();

					let num_of_row = 0;
					let box_height = 0;
					let num_of_letter_line = Math.floor(((width - padding_inner * 2) * width_percent) / font_size);
					num_of_letter_line -= 3; // 3칸 여분
					if (num_of_letter_line < 1) num_of_letter_line = 1;

					let arr = [];
					let from_idx = 0;
					let bf = '';
					while (from_idx < str.length) {
						let idx = str.indexOf(' ', from_idx);
						let sub = idx > -1 ? str.substring(from_idx, idx) : str.substring(from_idx);

						if (bf.length + sub.length > num_of_letter_line) {
							if (sub.length > permit_limit) {
								arr.push((bf + sub).substring(0, num_of_letter_line));
								from_idx += num_of_letter_line - bf.length;
								bf = '';
							} else {
								arr.push(bf);

								from_idx = idx < 0 ? str.length : idx + 1;
								if (idx < 0) arr.push(sub);
								else bf = sub + ' ';
							}
						} else {
							if (bf.length + sub.length + permit_limit < num_of_letter_line) {
								bf = bf + sub;

								from_idx = idx < 0 ? str.length : idx + 1;
								if (idx < 0) arr.push(bf);
								else bf += ' ';
							} else {
								from_idx = idx < 0 ? str.length : idx + 1;

								arr.push(bf + sub);
								bf = '';
							}
						}
					}

					num_of_row = arr.length;
					box_height = font_size * num_of_row + padding_inner * 2;

					// console.log({ str, num_of_row, font_size, box_height });
					return { arr, num_of_row, font_size, box_height };
				};

				for (let label of boxLabelArr) {
					let class_code_row = makeRowInfo(label.item_class_code, big_font_size, 1);
					let class_name_row = makeRowInfo(label.item_class_name, big_font_size, 1);
					let item_color_row = makeRowInfo(label.item_color, big_font_size, 0.7);
					// item_amount_row의 경우, box_height는 item_color_row를 따르고 font-size도 item_color_row보다 큰 경우, item_color_row 따름.
					let item_amount_row = makeRowInfo(label.item_amount, big_font_size, 0.3);

					while (class_code_row.num_of_row > 1 || class_code_row.box_height > code_height) {
						class_code_row = makeRowInfo(label.item_class_code, class_code_row.font_size - 10, 1);
					}
					while (item_color_row.num_of_row > 1 || item_color_row.box_height > color_height) {
						item_color_row = makeRowInfo(label.item_color, item_color_row.font_size - 10, 0.7);
					}
					while (item_amount_row.num_of_row > 1 || item_amount_row.box_height > pcs_height) {
						item_amount_row = makeRowInfo(label.item_amount, item_amount_row.font_size - 10, 0.3);
					}
					while (class_name_row.box_height > name_height) {
						class_name_row = makeRowInfo(label.item_class_name, class_name_row.font_size - 10, 1);
					}

					let benchmark = { x: 0, y: 0 };

					str_body += '^XA';
					str_body += '^FWR'; // 90도 회전, 문서 전체 90도 회전 명령어는 없음.(^POI는 180도 회전)

					// Class Code
					benchmark.x = padding_outer + height - code_height;
					benchmark.y = padding_outer;
					str_body += `^FO${benchmark.x},${benchmark.y}^GB${code_height},${width},${line_thick}^FS`; //'^FO20,20^GB1178,260,5^FS'

					benchmark.x = padding_outer + height - padding_inner - (code_height - class_code_row.box_height) / 2;
					benchmark.y = padding_outer;
					class_code_row.arr.forEach((el, index) => {
						str_body += `^FO${benchmark.x - (index + 1) * class_code_row.font_size},${benchmark.y}^FB${width},1,0,C^AD,${class_code_row.font_size},${class_code_row.font_size}^FD${el}\\&^FS`;
					});

					// Class Name
					benchmark.x = padding_outer + height - (code_height + name_height);
					benchmark.y = padding_outer;
					str_body += `^FO${benchmark.x},${benchmark.y}^GB${name_height},${width},${line_thick}^FS`; // ^FO20,280^GB1178,272,5^FS'

					benchmark.x = padding_outer + height - code_height - padding_inner - (name_height - class_name_row.box_height) / 2;
					benchmark.y = padding_outer;
					class_name_row.arr.forEach((el, index) => {
						str_body += `^FO${benchmark.x - (index + 1) * class_name_row.font_size},${benchmark.y}^FB${width},1,0,C^AD,${class_name_row.font_size},${class_name_row.font_size}^FD${el}\\&^FS`;
					});

					// Item Color
					benchmark.x = padding_outer;
					benchmark.y = padding_outer;

					str_body += `^FO${benchmark.x},${benchmark.y}^GB${color_height},${Math.floor(width * 0.7)},${line_thick}^FS`; // '^FO20,552^GB1178,260,5^FS'

					benchmark.x = padding_outer + height - (code_height + name_height) - padding_inner - (color_height - item_color_row.box_height) / 2;
					benchmark.y = padding_outer;
					item_color_row.arr.forEach((el, index) => {
						str_body += `^FO${benchmark.x - (index + 1) * item_color_row.font_size},${benchmark.y}^FB${Math.floor(width * 0.7)},1,0,C^AD,${item_color_row.font_size},${item_color_row.font_size}^FD${el}\\&^FS`;
					});

					// PCS Text
					benchmark.x = padding_outer + pcs_height;
					benchmark.y = padding_outer + Math.floor(width * 0.7);

					str_body += `^FO${benchmark.x},${benchmark.y}^GB${pcs_label_height},${width - Math.floor(width * 0.7)},${line_thick}^FS`;

					benchmark.x = padding_outer + height - (code_height + name_height) - 15;
					benchmark.y = padding_outer + Math.floor(width * 0.7);
					str_body += `^FO${benchmark.x - (pcs_label_height - 8)},${benchmark.y}^FB${width - Math.floor(width * 0.7)},1,0,C`;
					str_body += `^AD,${pcs_label_height - 5},${pcs_label_height - 4}^FDPSC\\&^FS`;

					// Item PCS
					benchmark.x = padding_outer;
					benchmark.y = padding_outer + Math.floor(width * 0.7);

					str_body += `^FO${benchmark.x},${benchmark.y}^GB${pcs_height},${width - Math.floor(width * 0.7)},${line_thick}^FS`;

					benchmark.x = padding_outer + height - (code_height + name_height + pcs_label_height) - padding_inner - (pcs_height - item_amount_row.box_height) / 2;
					benchmark.y = padding_outer + Math.floor(width * 0.7);
					item_amount_row.arr.forEach((el, index) => {
						str_body += `^FO${benchmark.x - (index + 1) * item_amount_row.font_size},${benchmark.y}^FB${width - Math.floor(width * 0.7)},1,0,C^AD,${item_amount_row.font_size},${item_amount_row.font_size}^FD${el}\\&^FS`;
					});

					str_body += '^XZ';
				}

				let str = '';
				/*
				str += '^XA';
				// str += '^SEE:UHANGUL.DAT^FS';
				// str += '^CW1,E:KFONT3.FNT^CI26^FS';
				// str += '^CF1,60';
				// str += '^DFR:INVBOX.ZPL^FS';
				str += '~TA000';
				str += '~JSN';
				str += '^LT0';
				str += '^MNW';
				str += '^MTT';
				str += '^PON';
				str += '^PMN';
				str += '^LH0,0';
				str += '^JMA';
				str += '^PR8,8';
				str += '~SD15';
				str += '^JUS';
				str += '^LRN';
				str += '^PA0,1,1,0';
				str += '^MMT';
				str += '^PW812';
				str += '^LL1218';
				str += '^LS0';
				// str += '^CF0,120';

				str += '^XZ';
				*/
				str += str_body;

				zplPrint(str);
				// console.log(str);
			}
		},
		allCheck() {
			this.boxLabelArr = [];
			if (this.itemColorCheckBox) {
				this.data.list.forEach(cls => {
					cls.items.forEach(item => {
						this.boxLabelArr.push(item.item_id);
					});
				});
			}
		},
	},
	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_inventory-sheet');
		this.$store.commit('setSubTitle', 'Report -> Inventory Sheet');
	},
};
</script>

<style scoped></style>
